import { useEffect, useState } from 'react';
import styles from './IMSAppRoleDescriptions.module.scss';
import MaterialIcon from '@material/react-material-icon';
import { Button } from '@upmc/ims.component-library';
import { nanoid } from 'nanoid';
import classNames from 'classnames';
const IMSAppRoleDescriptions = ({ name, onChange, disabled, field }) => {
	const initialState =
		field && field.PendingUpdateApprovalValue
			? JSON.parse(field.PendingUpdateApprovalValue)
			: [];
	const [roleDescriptions, setRoleDescriptions] = useState(initialState);

	//when role descriptions changes, call onChange to update parent state
	useEffect(() => {
		//mock event object
		let event = {
			target: {
				name: name,
				value: JSON.stringify(roleDescriptions),
			},
		};
		//call onChange prop and pass mock event to update object
		onChange(event);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [roleDescriptions]);

	const addRoleDescription = () => {
		let updatedRoleDesciptions = [...roleDescriptions];
		updatedRoleDesciptions.push(new RoleDescription());
		setRoleDescriptions(updatedRoleDesciptions);
	};

	const handleDescriptionChange = (event, id) => {
		let roleDescription = roleDescriptions.find(rd => rd.id === id);
		roleDescription.description = event.target.value;
		setRoleDescriptions([...roleDescriptions]);
	};

	const handleRoleChange = (event, id) => {
		let roleDescription = roleDescriptions.find(rd => rd.id === id);
		roleDescription.role = event.target.value;
		setRoleDescriptions([...roleDescriptions]);
	};

	const removeRoleDescription = roleDescription => {
		let updatedRoleDescriptions = roleDescriptions.filter(
			rd => rd.id !== roleDescription.id
		);
		setRoleDescriptions([...updatedRoleDescriptions]);
	};

	return (
		<div className={styles.width_full}>
			<div>
				<div className={styles.flex_column}>
					{roleDescriptions.map(roleDescription => {
						return (
							<div
								className={classNames([
									styles.margin_y_small,
									styles.align_center,
								])}
							>
								<label className={styles.margin_x_small}>
									Role Name
								</label>
								<input
									type='text'
									value={roleDescription.role}
									id={roleDescription.id}
									onChange={e => {
										handleRoleChange(e, roleDescription.id);
									}}
									disabled={disabled}
									name='role'
								/>
								<label className={styles.margin_x_small}>
									Role Description
								</label>
								<textarea
									disabled={disabled}
									type='text'
									value={roleDescription.description}
									id={roleDescription.id}
									onChange={e => {
										handleDescriptionChange(
											e,
											roleDescription.id
										);
									}}
									name='description'
									cols={20}
									rows={5}
								/>
								<Button
									variant='outlined'
									startIcon={<MaterialIcon icon='delete' />}
									sx={{ mx: '1em', my: '.5em' }}
									onClick={e =>
										removeRoleDescription(roleDescription)
									}
									disabled={disabled}
								>
									Remove
								</Button>
							</div>
						);
					})}
				</div>
				<div
					className={classNames([
						styles.flex_center,
						styles.margin_y_small,
					])}
				>
					<Button
						startIcon={<MaterialIcon icon='add' />}
						onClick={e => addRoleDescription()}
						disabled={disabled}
					>
						Add Role Description
					</Button>
				</div>
			</div>
		</div>
	);
};

export default IMSAppRoleDescriptions;

class RoleDescription {
	constructor() {
		this.role = null;
		this.description = null;
		this.id = nanoid();
	}
}
